import { Download, FileSpreadsheet, FilterX, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtEuro } from "@/lib/rows";

const Total = ({ label, value, tone, testId }) => (
  <div className="rounded-lg border border-slate-200 bg-white px-4 py-2">
    <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400">{label}</p>
    <p data-testid={testId} className={`font-mono text-sm font-semibold ${tone}`}>{value}</p>
  </div>
);

export const GridToolbar = ({ rows, total, nFilters, onClear, onExport, exporting }) => {
  const deb = rows.reduce((s, r) => s + (r.deb || 0), 0);
  const cred = rows.reduce((s, r) => s + (r.cred || 0), 0);
  const label = nFilters ? `${rows.length} ${rows.length === 1 ? "riga filtrata" : "righe filtrate"}` : `tutte le ${total} righe`;
  return (
    <div className="mb-4 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="flex flex-wrap items-center gap-2">
        <Total label="Righe" value={`${rows.length} / ${total}`} tone="text-slate-900" testId="grid-row-count" />
        <Total label="Addebiti" value={`€ ${fmtEuro(deb)}`} tone="text-red-600" testId="grid-total-addebiti" />
        <Total label="Accrediti" value={`€ ${fmtEuro(cred)}`} tone="text-emerald-700" testId="grid-total-accrediti" />
        <Total label="Saldo righe" value={`€ ${fmtEuro(cred - deb)}`} tone="text-slate-900" testId="grid-total-saldo" />
        {nFilters > 0 && (
          <Button variant="ghost" size="sm" data-testid="clear-all-filters" onClick={onClear} className="text-slate-600">
            <FilterX className="mr-1.5 h-4 w-4" /> Rimuovi filtri ({nFilters})
          </Button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        <Button data-testid="download-xlsx-button" disabled={!rows.length || !!exporting} onClick={() => onExport("xlsx")}
          className="h-11 rounded-full bg-emerald-700 px-5 text-white hover:bg-emerald-800 btn-lift">
          {exporting === "xlsx" ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FileSpreadsheet className="mr-2 h-4 w-4" />}
          Scarica Excel · {label}
        </Button>
        <Button data-testid="download-csv-button" disabled={!rows.length || !!exporting} onClick={() => onExport("csv")}
          className="h-11 rounded-full bg-slate-900 px-5 text-white hover:bg-slate-800 btn-lift">
          {exporting === "csv" ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Download className="mr-2 h-4 w-4" />}
          CSV
        </Button>
      </div>
    </div>
  );
};
